import { Tabs } from "client/CommonComponents"
import OrderDetailViewBreadcrumb from "../OrderDetailView/OrderDetailViewBreadcrumb"
import OrderDetailView from "../OrderDetailView";
import PurchaseOrder from "../PurchaseOrder";
import PurchaseOrderBreadcrumb from "../PurchaseOrder/PurchaseOrderBreadcrumb";
import { useSelector } from "react-redux";
import { CONSTANTS } from "client/utils/constants";
import { useEffect } from "react";
import PurchaseBulkOrder from "../PurchaseBulkOrder";
import ApprovalHistory from "../ApprovalHistory";

const OrderDetailViewContainer = (props:any) => {
  const { tab } = props

  const selectedKey = props?.selectedKey
  const setSelectedKey = props?.setSelectedKey
  const tabSwitchClicked = props?.tabSwitchClicked
  const setTabSwitchClicked = props?.setTabSwitchClicked
  const setShowFleetBreadcrumb = props?.setShowFleetBreadcrumb
  const isBulkOrder = props?.isBulkOrder

  const { orderDetailsView }: any = useSelector((state: any) => ({
    orderDetailsView: state.OrderReducer.orderByIdData,
  }));


  const tabItems = [
    {
      itemKey: "requisition",
      headerText: "Order Details",
      content: <OrderDetailView
        isBulkOrder={isBulkOrder}
        tab={tab}
        setSelectedKey={setSelectedKey}
        tabSwitchClicked={tabSwitchClicked}
        setTabSwitchClicked={setTabSwitchClicked}
      />
    }
    ];

  if (orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.FLEET_PROCESSING || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED) {
    tabItems.push(
      {
        itemKey: "approvalHistory",
        headerText: "Approval History",
        content: <ApprovalHistory
          setSelectedKey={props.setSelectedKey}
          tab={tab}
          tabSwitchClicked={props.tabSwitchClicked}
          setTabSwitchClicked={props.setTabSwitchClicked}
        />
      },
      {
        itemKey: "fleet-processing",
        headerText: "Fleet Processing",
        content:
          isBulkOrder ?
            <PurchaseBulkOrder
              selectedKey={selectedKey}
              setSelectedKey={setSelectedKey}
              tabSwitchClicked={tabSwitchClicked}
              setTabSwitchClicked={setTabSwitchClicked}
              setShowFleetBreadcrumb={setShowFleetBreadcrumb}
              tab={tab}
            /> : <PurchaseOrder
              selectedKey={selectedKey}
              setSelectedKey={setSelectedKey}
              tabSwitchClicked={tabSwitchClicked}
              setTabSwitchClicked={setTabSwitchClicked}
              setShowFleetBreadcrumb={setShowFleetBreadcrumb}
              isBulkOrder={isBulkOrder}
              tab={tab}
            />
      }
    )
  }

  useEffect(()=>{
    if(orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.FLEET_PROCESSING || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED){
      setSelectedKey("fleet-processing")
      setShowFleetBreadcrumb(true)
    }
  }, [orderDetailsView?.orderStatus])

  if (orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.PENDING_APPROVAL || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.REJECTED || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.RETURNED_TO_REQUESTOR || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.RETURNED || orderDetailsView?.orderStatus === CONSTANTS?.ORDER_STATUS?.DELETED) {
    return <>
    <OrderDetailViewBreadcrumb />
    <OrderDetailView isBulkOrder={isBulkOrder}/>
    </>
  }

  return (<div className="myOrderDetial" ref={props.wrapperRef}>
    {!props?.showFleetBreadcrumb ? <OrderDetailViewBreadcrumb /> : <PurchaseOrderBreadcrumb isBulkOrder={isBulkOrder}/>}
    <Tabs
      className={`custom-tab `}
      tabItems={tabItems}
      selectedKey={props?.selectedKey}
      handleLinkClick={props?.handleLinkClick}
     data-attribute="OrderDetailViewMainContainer_Default_Tabs" />
  </div>)
}

export default OrderDetailViewContainer